import { render, staticRenderFns } from "./ReceiptScanDialog.vue?vue&type=template&id=5197f108&scoped=true"
import script from "./ReceiptScanDialog.vue?vue&type=script&lang=js"
export * from "./ReceiptScanDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5197f108",
  null
  
)

export default component.exports